/**
 * NotificationBadge Component
 *
 * iPhone-style notification badge with count display
 * Features:
 * - Red badge with white text (iOS style)
 * - Pulse animation for critical alerts
 * - Compact display (99+) for high counts
 * - Flexible positioning (top-right, top-left, etc.)
 */

import React from 'react';
import styles from './NotificationBadge.module.css';

export default function NotificationBadge({
  count = 0,
  variant = 'critical',
  position = 'top-right',
  pulse = false,
  maxCount = 99
}) {
  // Don't render if count is 0 or negative
  if (count <= 0) {
    return null;
  }

  // Format count display (e.g., 99+)
  const displayCount = count > maxCount ? `${maxCount}+` : count;

  // Determine CSS classes
  const badgeClasses = [
    styles.badge,
    styles[variant],
    styles[position],
    pulse && styles.pulse
  ].filter(Boolean).join(' ');

  return (
    <div className={badgeClasses}>
      <span className={styles.count}>{displayCount}</span>
    </div>
  );
}
